export default {
    '2b-diagram1': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'Firestone’s most important commitment was his initial move to Akron',
            'two': 'Ecosystem of supporting institutions',
            'three': 'Place to socialize and talk shop',
            'four': 'On the cutting edge of rubber technology',
        }
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram1/i18n/en.js